import React, { useState, useEffect } from 'react';
import { DrawIcon } from '../icons';
import FolderSelect from './FolderSelect';
// import ImageEditor from './ImageEditor';
import ImageEditor from '../../components/views/ImageEditor';
import { AccentButton, Button } from './Button';
import Window from './Window';

const CreateImageItem = ({
  onCancel,
  onAdd,
  onFileSelect,
  onDraw,
  className = "",
  imageUrl = "",
  folderOptions = [],
  defaultFolderId = null
}) => {
  const [selectedFolder, setSelectedFolder] = useState(
    () => folderOptions.find(f => f.value === defaultFolderId) || folderOptions[0] || null
  );
  const [isEditorMode, setIsEditorMode] = useState(false);
  const [handledImageUrl, setHandledImageUrl] = useState(imageUrl);

  useEffect(() => {
    setHandledImageUrl(imageUrl);
  }, [imageUrl]);

  // folderOptions are provided by parent (FolderPage)

  const handleFolderChange = (folder) => {
    setSelectedFolder(folder);
    if (onFileSelect) {
      onFileSelect(folder);
    }
  };

  const handleNewFolder = () => {
    console.log('Create new folder');
    // Add logic to create new folder
  };

  const handleDrawClick = () => {
    setIsEditorMode(true);
    if (onDraw) {
      onDraw();
    }
  };

  const handleEditorCancel = () => {
    setIsEditorMode(false);
  };

  const handleEditorApply = (imageBlob) => {
    setIsEditorMode(false);
    setHandledImageUrl(URL.createObjectURL(imageBlob));
  };

  // If in editor mode, show ImageEditor
  if (isEditorMode) {
    return (
      <ImageEditor
        src={handledImageUrl}
        onCancel={handleEditorCancel}
        onSave={handleEditorApply}
        className={className}
        isOpen={true}
      />
    );
  }

  return (
    <Window
      className={className}
      bottomLeft={(
        <>
          <FolderSelect
            value={selectedFolder?.value}
            onChange={handleFolderChange}
            options={folderOptions}
            onNewFolder={handleNewFolder}
            placeholder="F name"
          />
          <Button variant="ghost" onClick={handleDrawClick} title="Draw" Icon={DrawIcon} />
        </>
      )}
      bottomRight={(
        <>
          <AccentButton variant="secondary" onClick={onCancel}>Cancel</AccentButton>
          <AccentButton variant="primary" onClick={() => onAdd && onAdd(selectedFolder)}>Add</AccentButton>
        </>
      )}
    >
      <div className="w-full h-full rounded-2xl flex items-center justify-center">
        <div className="w-full h-full flex items-center justify-center">
          <img
            src={handledImageUrl}
            alt=""
            className="max-w-full max-h-full object-contain"
          />
        </div>
      </div>
    </Window>
  );
};

export default CreateImageItem;


